import { z } from 'zod';

export const pictureDataUriSchema = z.string().max(65_536).regex(/^data:image\/(?:png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$/);
export const tradeBodyLimitBytes = 2 * 1024 * 1024;
